import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-create-event-popup',
    templateUrl: './create-event-popup.component.html',
    styleUrls: ['./create-event-popup.component.scss'],
    standalone: false // NOSONAR
})
export class CreateEventPopupComponent implements OnInit {

  //@Output() proceedEvent = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<CreateEventPopupComponent>) { }

  ngOnInit(): void {
    console.info('something')
  }

  close() {
    this.dialogRef.close();
  }
  onProceed() {
    this.dialogRef.close('proceed');
  }
}
